/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { Link } from 'react-router';

import { RouteNames } from 'pages/teach-course/constants';

import { Typography2 } from '@coursera/cds-core';

type Props = {
  courseSlug: string;
  contextId: string;
  itemId: string;
  itemName: string;
};

const styles = {
  itemNameLink: css`
    color: var(--cds-color-neutral-primary);
    text-decoration: underline;
    max-width: 33vw;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    &:focus,
    &:hover,
    &:active {
      color: var(--cds-color-interactive-primary);
    }
  `,
};

// Component for SGA top bar assignment name display with redirect to authoring page
const AssignmentNameDisplay = ({ courseSlug, contextId, itemId, itemName }: Props) => {
  return (
    <Link
      to={{
        name: RouteNames.STAFF_GRADED_AUTHOR,
        params: { courseSlug, contextId, itemId },
      }}
      target="_blank"
      rel="noopener noreferrer"
      css={styles.itemNameLink}
    >
      <Typography2 variant="bodyPrimary" component="span" color="inherit">
        {itemName}
      </Typography2>
    </Link>
  );
};

export default AssignmentNameDisplay;
